module.exports = __webpack_public_path__ + "img/packshots-desktop.eb5d075f.png";